module.exports = __webpack_public_path__ + "img/public/siteImages/mailIcon.svg?9e79d54a";